// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/ProductIntroduction/IntroducingOurProduct.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productMainDiv {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: transparent !important;
}

.childDiv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
}

.referModalMObileView {
  width: 700px;
  height: 415px;
  flex-shrink: 0;
  border-radius: 33px;
}

.childDiv1,
.childDiv2,
.childDiv3 {
  height: 8vw;
}

.childDiv1,
.childDiv3 {
  display: flex;
  justify-content: end;
}

.childDiv2 {
  display: flex;
  align-items: center;
}

.childDiv3 {
  align-items: end;
}

.childDivData {
  height: 8vw;
  width: 18vw;
  border-radius: 4vw;
  background-color: #fff;
  position: absolute;
  display: flex;
  align-items: center;
}

.childDivData1 {
  margin-top: -1.5vw;
}
@media (min-width: 1600px) and (max-width: 1920px) {
  .childDivData1 {
    margin-top: 1.5vw;
  }
}
@media (min-width: 1400px) and (max-width: 1600px) {
  .childDivData1 {
    margin-top: 2.5vw;
  }
}
@media (max-width: 990px) {
  .childDivData1 {
    width: 35vw !important;
    margin-right: -16vw !important;
  }
}

.childDivData2 {
  margin-left: -1vw;
  margin-top: 2vw;
}
@media (max-width: 1201px) {
  .childDivData2 {
    margin-left: -5vw;
  }
}
@media (max-width: 990px) {
  .childDivData2 {
    width: 37vw !important;
    margin-left: -10vw !important;
    margin-top: -6vw !important;
  }
}

.childDivData3 {
  margin-bottom: -20vw;
  margin-right: -5vw;
  width: 25vw !important;
}
@media (min-width: 1800px) {
  .childDivData3 {
    margin-bottom: -36vh;
  }
}
@media (max-width: 1201px) {
  .childDivData3 {
    width: 35vw !important;
    margin-bottom: 10vw;
    margin-right: -10vw;
  }
}
@media (max-width: 990px) {
  .childDivData3 {
    width: 40vw !important;
  }
}

.childDivData4 {
  margin-bottom: -45vw;
}
@media (max-width: 1201px) {
  .childDivData4 {
    margin-left: -10vw;
    margin-bottom: -10vw;
  }
}
@media (max-width: 990px) {
  .childDivData4 {
    width: 35vw !important;
  }
}

.childDivDataMob {
  display: none;
}

@media (max-width: 1200px) {
  .childDiv {
    width: 60vw;
    height: 60vw;
  }
  .childDiv1,
  .childDiv2,
  .childDiv3 {
    height: 17vw;
  }
  .childDivData {
    height: 12vw;
    width: 22vw;
    border-radius: 7vw;
    background-color: #fff;
    position: absolute;
  }
}
@media (max-width: 768px) {
  .childDiv {
    width: 80vw;
    height: 80vw;
  }
  .childDiv1,
  .childDiv2,
  .childDiv3 {
    height: 18vh;
  }
  .childDivData3 {
    margin-bottom: -6.5vh;
    margin-right: -4vh;
  }
  .childDivData {
    display: none;
  }
  .childDivDataMob {
    display: flex;
    height: 32vw;
    width: 70vw;
    border-radius: 15vw;
    background-color: #fff;
    text-align: center;
    margin-bottom: 1vh;
    align-items: center;
  }
}
@media (max-width: 576px) {
  .mainDivMobile {
    width: 100vh;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .childDiv11 {
    border: 1px solid green;
    height: 20vh;
    width: 100vh;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .childDivData111 {
    border: 1px solid green;
    height: 20vh;
    width: 78vh;
  }
}
.product {
  padding-top: 11vh;
}
.product_mainRowProduct {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 120px;
  z-index: 2;
  margin-top: 2rem;
}
@media (max-width: 1200px) {
  .product_mainRowProduct {
    margin-bottom: 0 !important;
  }
}
.product_orange-gradient {
  width: 45vw;
  height: 80vh;
  border-radius: 100%;
  opacity: 0.6000000238;
  background: rgba(240, 89, 42, 0.4);
  filter: blur(150px);
  z-index: -1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product_heading {
  color: #fff;
  font-size: 1.9vw;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 150%;
  margin-bottom: 1rem;
  letter-spacing: 4px;
}
@media (max-width: 1200px) {
  .product_heading {
    color: #fff;
    font-size: 2.6rem;
    line-height: 150%;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: normal;
  }
}
@media (max-width: 575px) {
  .product_heading {
    font-size: 1.6rem;
  }
}
.product_textColProduct {
  padding: 5vh;
  margin: 10vh 0;
}
@media (max-width: 1200px) {
  .product_textColProduct {
    margin: 0 !important;
  }
}
.product_mobColProduct {
  display: none;
}
@media (max-width: 768px) {
  .product_mobColProduct {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
.product_subHeading {
  color: #fff;
  font-size: 1.5vw;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
@media (max-width: 1200px) {
  .product_subHeading {
    color: #fff;
    font-size: 18px;
  }
}
@media (max-width: 575px) {
  .product_subHeading {
    font-size: 5vw;
  }
}

.product_heading span {
  color: var(--orange---0, #F0592A);
  font-family: Roboto;
  font-size: 3vw;
  font-style: normal;
  font-weight: 900;
  line-height: 60px;
  letter-spacing: 5px;
  text-transform: uppercase;
  padding-right: 1vw;
}
@media only screen and (min-width: 1080px) and (max-width: 1680px) {
  .product_heading span {
    padding-right: 0vw;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  .product_heading span {
    padding-right: 1vw;
    font-size: 4.5vw;
  }
}
@media (max-width: 992px) {
  .product_heading span {
    padding-right: 0vw;
    font-size: 6.5vw;
  }
}
@media (max-width: 576px) {
  .product_heading span {
    padding-right: 0vw;
    font-size: 10vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/HomePage/ProductSection/productSection.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AACF;;AAEA;EACE,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACF;;AACA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AAOA;;;EAGE,WAAA;AAJF;;AAOA;;EAEE,aAAA;EACA,oBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;AAKE;EAFF;IAGI,iBAAA;EAFF;AACF;AAGE;EALF;IAMI,iBAAA;EAAF;AACF;AAIE;EAXF;IAYI,sBAAA;IACA,8BAAA;EADF;AACF;;AAIA;EACE,iBAAA;EACA,eAAA;AADF;AAEE;EAHF;IAII,iBAAA;EACF;AACF;AAAE;EANF;IAOI,sBAAA;IACF,6BAAA;IACE,2BAAA;EAGF;AACF;;AAAA;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;AAGF;AAFE;EAJF;IAKI,oBAAA;EAKF;AACF;AAJE;EAPF;IAQI,sBAAA;IACA,mBAAA;IACA,mBAAA;EAOF;AACF;AANE;EAZF;IAaI,sBAAA;EASF;AACF;;AALA;EACE,oBAAA;AAQF;AAPE;EAFF;IAGI,kBAAA;IACA,oBAAA;EAUF;AACF;AATE;EANF;IAOI,sBAAA;EAYF;AACF;;AARA;EACE,aAAA;AAWF;;AARA;EACE;IACE,WAAA;IACA,YAAA;EAWF;EARA;;;IAGE,YAAA;EAUF;EAPA;IACE,YAAA;IACA,WAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;EASF;AACF;AALA;EACE;IACE,WAAA;IACA,YAAA;EAOF;EAJA;;;IAGE,YAAA;EAMF;EAHA;IACE,qBAAA;IACA,kBAAA;EAKF;EAFA;IACE,aAAA;EAIF;EADA;IACE,aAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,kBAAA;IACA,mBAAA;EAGF;AACF;AAAA;EACE;IACE,YAAA;IACA,uBAAA;IACA,aAAA;IACA,mBAAA;EAEF;EACA;IACE,uBAAA;IACA,YAAA;IACA,YAAA;IACA,uBAAA;IACA,aAAA;IACA,mBAAA;EACF;EAEA;IACE,uBAAA;IACA,YAAA;IACA,WAAA;EAAF;AACF;AAGA;EAwDE,iBAAA;AAxDF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;AACJ;AAAI;EANF;IAOI,2BAAA;EAGJ;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AACE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AACI;EAVF;IAWI,WAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,yBAAA;IACA,sBAAA;EAEJ;AACF;AAAI;EAnBF;IAoBI,iBAAA;EAGJ;AACF;AADE;EACE,YAAA;EACA,cAAA;AAGJ;AAFI;EAHF;IAII,oBAAA;EAKJ;AACF;AADE;EACE,aAAA;AAGJ;AAFI;EAFF;IAGI,aAAA;IACA,uBAAA;IACA,WAAA;EAKJ;AACF;AAFE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIJ;AAHI;EANF;IAOI,WAAA;IACA,eAAA;EAMJ;AACF;AAJI;EAXF;IAYI,cAAA;EAOJ;AACF;;AAHA;EACE,iCAAA;EACF,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACE,kBAAA;AAMF;AALE;EAVF;IAWI,kBAAA;EAQF;AACF;AAPE;EAbF;IAcI,kBAAA;IACA,gBAAA;EAUF;AACF;AATE;EAjBF;IAkBI,kBAAA;IACA,gBAAA;EAYF;AACF;AAXE;EArBF;IAsBI,kBAAA;IACA,eAAA;EAcF;AACF","sourcesContent":[".productMainDiv {\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  background-color: transparent !important;\n}\n\n.childDiv {\n  background-image: url(\"../../../assets/images/ProductIntroduction/IntroducingOurProduct.jpg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  cursor: pointer;\n}\n.referModalMObileView {\n  width: 700px;\n  height: 415px;\n  flex-shrink: 0;\n  border-radius: 33px;\n  // background: #020C2E;\n  // flex-shrink: 0;\n  // border-radius: 26px;\n  // color: #000;\n  // // position: absolute;\n  // right: 0px;\n}\n\n.childDiv1,\n.childDiv2,\n.childDiv3 {\n  height: 8vw;\n}\n\n.childDiv1,\n.childDiv3 {\n  display: flex;\n  justify-content: end;\n}\n\n.childDiv2 {\n  display: flex;\n  align-items: center;\n}\n\n.childDiv3 {\n  align-items: end;\n}\n\n.childDivData {\n  height: 8vw;\n  width: 18vw;\n  border-radius: 4vw;\n  background-color: #fff;\n  position: absolute;\n  display: flex;\n  align-items: center;\n}\n\n.childDivData1 {\n  margin-top: -1.5vw;\n  @media (min-width: 1600px) and (max-width: 1920px) {\n    margin-top: 1.5vw;\n  }\n  @media (min-width: 1400px) and (max-width: 1600px) {\n    margin-top: 2.5vw;\n  }\n  @media (min-width: 1024px) and (max-width: 1366px) {\n    // margin-top: 2.5vw;\n  }\n  @media (max-width:990px){\n    width:35vw !important;\n    margin-right: -16vw !important;\n  }\n}\n\n.childDivData2 {\n  margin-left: -1vw;\n  margin-top: 2vw;\n  @media (max-width: 1201px) {\n    margin-left: -5vw;\n  }\n  @media (max-width:990px){\n    width:37vw !important;\n  margin-left: -10vw !important;\n    margin-top: -6vw !important;\n  }\n}\n\n.childDivData3 {\n  margin-bottom: -20vw;\n  margin-right: -5vw;\n  width: 25vw !important;\n  @media (min-width: 1800px) {\n    margin-bottom: -36vh;\n  }\n  @media (max-width: 1201px) {\n    width: 35vw !important;\n    margin-bottom: 10vw;\n    margin-right: -10vw;\n  }\n  @media (max-width:990px){\n    width:40vw !important;\n  }\n \n}\n\n.childDivData4 {\n  margin-bottom: -45vw;\n  @media (max-width: 1201px) {\n    margin-left: -10vw;\n    margin-bottom: -10vw;\n  }\n  @media (max-width:990px){\n    width:35vw !important;\n    // margin-right: 20vw !important;\n  }\n}\n\n.childDivDataMob {\n  display: none;\n}\n\n@media (max-width: 1200px) {\n  .childDiv {\n    width: 60vw;\n    height: 60vw;\n  }\n\n  .childDiv1,\n  .childDiv2,\n  .childDiv3 {\n    height: 17vw;\n  }\n\n  .childDivData {\n    height: 12vw;\n    width: 22vw;\n    border-radius: 7vw;\n    background-color: #fff;\n    position: absolute;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .childDiv {\n    width: 80vw;\n    height: 80vw;\n  }\n\n  .childDiv1,\n  .childDiv2,\n  .childDiv3 {\n    height: 18vh;\n  }\n\n  .childDivData3 {\n    margin-bottom: -6.5vh;\n    margin-right: -4vh;\n  }\n\n  .childDivData {\n    display: none;\n  }\n\n  .childDivDataMob {\n    display: flex;\n    height: 32vw;\n    width: 70vw;\n    border-radius: 15vw;\n    background-color: #fff;\n    text-align: center;\n    margin-bottom: 1vh;\n    align-items: center;\n  }\n}\n\n@media (max-width: 576px) {\n  .mainDivMobile {\n    width: 100vh;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n  }\n\n  .childDiv11 {\n    border: 1px solid green;\n    height: 20vh;\n    width: 100vh;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n  }\n\n  .childDivData111 {\n    border: 1px solid green;\n    height: 20vh;\n    width: 78vh;\n  }\n}\n\n.product {\n  &_mainRowProduct {\n    padding-left: 24px;\n    padding-right: 24px;\n    margin-bottom: 120px;\n    z-index: 2;\n    margin-top: 2rem;\n    @media (max-width: 1200px) {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &_orange-gradient {\n    width: 45vw;\n    height: 80vh;\n    border-radius: 100%;\n    opacity: 0.6000000238418579;\n    background: rgba(240, 89, 42, 0.4);\n    filter: blur(150px);\n    z-index: -1;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &_heading {\n    color: #fff;\n    font-size: 1.9vw;\n    font-style: normal;\n    font-weight: 700;\n    text-transform: uppercase;\n    line-height: 150%;\n    margin-bottom: 1rem;\n    letter-spacing: 4px;\n\n    @media (max-width: 1200px) {\n      color: #fff;\n      font-size: 2.6rem;\n      line-height: 150%;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: normal;\n    }\n\n    @media (max-width: 575px) {\n      font-size: 1.6rem;\n    }\n  }\n  &_textColProduct {\n    padding: 5vh;\n    margin: 10vh 0;\n    @media (max-width: 1200px) {\n      margin: 0 !important;\n    }\n  }\n  padding-top: 11vh;\n\n  &_mobColProduct {\n    display: none;\n    @media (max-width: 768px) {\n      display: flex;\n      justify-content: center;\n      width: 100%;\n    }\n  }\n\n  &_subHeading {\n    color: #fff;\n    font-size: 1.5vw;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    @media (max-width: 1200px) {\n      color: #fff;\n      font-size: 18px;\n    }\n\n    @media (max-width: 575px) {\n      font-size: 5vw;\n    }\n  }\n}\n\n.product_heading span {\n  color: var(--orange---0, #F0592A);\nfont-family: Roboto;\nfont-size: 3vw;\nfont-style: normal;\nfont-weight: 900;\nline-height: 60px;\nletter-spacing: 5px;\ntext-transform: uppercase;\n  padding-right: 1vw ;\n  @media only screen and  (min-width:1080px) and (max-width:1680px)  {\n    padding-right: 0vw ;\n  }\n  @media only screen and  (min-width:1024px) and (max-width:1280px)  {\n    padding-right: 1vw ;\n    font-size: 4.5vw;\n  }\n  @media (max-width:992px) {\n    padding-right: 0vw ;\n    font-size: 6.5vw;\n  }\n  @media (max-width:576px) {\n    padding-right: 0vw ;\n    font-size: 10vw;\n  }\n\n}\n\n// .product_heading span:after {\n//   content: \"\";\n//   display: block;\n//   height: calc(100% - 0.65em);\n//   border: solid #fff281;\n//   position: absolute;\n//   top: 0.6em;\n//   left: 7em;\n//   width: calc(100% - 9em);\n//   border-width: 0.18em 0;\n\n//   @media (max-width: 1200px) {\n//     height: calc(100% - 0.52em);\n//     top: 0.48em;\n//     left: 5em;\n//     width: calc(100% - 7em);\n//     border-width: 0.14em 0;\n//   }\n\n//   @media (max-width: 900px) {\n//     height: calc(100% - 0.45em);\n//     top: 0.42em;\n//     left: 4.8em;\n//     width: calc(100% - 6.5em);\n//     border-width: 0.12em 0;\n//   }\n\n//   @media (max-width: 730px) {\n//     height: calc(100% - 0.48em);\n//     top: 0.42em;\n//     left: 4em;\n//     width: calc(100% - 5.5em);\n//     border-width: 0.12em 0;\n//   }\n//   @media (max-width: 380px) {\n//     height: calc(100% - 0.75em);\n//     top: 0.7em;\n//     left: 8em;\n//     width: 0.5em;\n//     border-width: 0.2em 0;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
